<script setup lang="ts">
import type { NuxtError } from 'nuxt/app'

defineOptions({
  inheritAttrs: false,
})

const props = defineProps<{
  error: NuxtError
}>()

// 监听错误变化，自动跳转到首页
onMounted(() => {
  // 无论什么错误，都跳转到首页
  navigateTo('/', { replace: true })
})
</script>

<template>
  <!-- 直接跳转到首页，不显示错误页面 -->
  <div></div>

  <!-- <ErrorNotFound v-if="error?.statusCode === 404" />
  <ErrorUnauthorized v-if="error?.statusCode === 403" />
  <ErrorUnderMaintenance v-if="error?.statusCode === 503" />
  <ErrorInternalServerError v-else :error="error" /> -->
</template>
